import React, { createContext, useContext, useState } from "react";

// Create Context
const CurrentSelectedDataContext = createContext();

// Provider component
export function CurrentSelectedDataProvider({ children }) {
  const [currentSelectedData, setCurrentSelectedData] = useState(null);

  return (
    <CurrentSelectedDataContext.Provider
      value={{ currentSelectedData, setCurrentSelectedData }}
    >
      {children}
    </CurrentSelectedDataContext.Provider>
  );
}

// Custom hook to use context
export function useCurrentSelectedData() {
  const context = useContext(CurrentSelectedDataContext);
  if (!context) {
    throw new Error(
      "useCurrentSelectedData must be used within a CurrentSelectedDataProvider"
    );
  }
  return context;
}
